import * as React from 'react';
import { Checkbox } from '../../../Forms/Checkbox';
import Tag from '../../../../models/Tag';
import './style.css';

export interface FilterBoxProps {
  disabled: boolean;
  selectedTags: Array<Tag>;
  tags: Array<Tag>;
  title: string;
  onChange: (tag: Tag, checked: boolean) => void;
}

export interface FilterBoxState {}

export class FilterBox extends React.Component<FilterBoxProps, FilterBoxState> {
  render() {
    const { disabled, onChange, selectedTags, tags, title } = this.props;

    return (
      <section className="search-filters-box">
        <h2>{title}</h2>
        <div className="labels-container">
          {tags.map(tag => (
            <label className="search-filter" key={`tag-filter-label-${tag.id}`}>
              <Checkbox
                checked={selectedTags.indexOf(tag) >= 0}
                disabled={disabled}
                onChange={({ currentTarget: { checked } }) =>
                  onChange(tag, checked)
                }
              />
              {tag.name}
            </label>
          ))}
        </div>
      </section>
    );
  }
}

export default FilterBox;



// WEBPACK FOOTER //
// ./src/app/components/Search/SearchForm/FilterBox/index.tsx